<template>
    <svg
        version="1.2"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        overflow="visible"
        preserveAspectRatio="none"
        viewBox="0 0 26 26"
        height="40"
        width="40">
        <g transform="translate(1, 1)">
            <g fill-rule="evenodd" fill="none" stroke-width="1" stroke="none" id="icon/misc/seat_1606194732368">
                <path fill="#256AB3" id="Combined-Shape_1606194732368" d="M18.5,2 C19.3284271,2 20,2.67157288 20,3.5 L20,10.312 L20.0261433,10.3953907 L20.9889345,14.8953907 C20.996521,14.9308493 21.0001442,14.9662339 21.0001029,15.0010834 L21,18 L20,18 L20,22 L17,22 L17,18 L12,18 L12,22 L9,22 L9,18 L8,18 L8,15 L8.00287469,14.9461306 L8.01190647,14.8915348 L8.23058075,13.9015956 C6.73933074,13.8438039 5.79490925,13.2933593 5.53278954,12.1651172 L5.5,12 L5.5,9.5 L3.5,9.5 C3.22385763,9.5 3,9.27614237 3,9 L3,7 C3,6.72385763 3.22385763,6.5 3.5,6.5 L9,6.5 L9,3.5 C9,2.67157288 9.67157288,2 10.5,2 L18.5,2 Z M11,18 L10,18 L10,21 L11,21 L11,18 Z M19,18 L18,18 L18,21 L19,21 L19,18 Z M20,16 L9,16 L9,17 L20,17 L20,16 Z M19.133,11 L9.901,11 L9.012,15 L19.989,15 L19.133,11 Z M9,9.5 L6.499,9.5 L6.4927708,11.9152832 C6.60464292,12.5660079 7.2101207,12.9066975 8.5,12.9066975 L8.452,12.905 L9,10.441 L9,9.5 Z M18.5,3 L10.5,3 C10.2238576,3 10,3.22385763 10,3.5 L10,6.5 L12.5,6.5 C12.7761424,6.5 13,6.72385763 13,7 L13,9 C13,9.27614237 12.7761424,9.5 12.5,9.5 L10,9.5 L10,10 L19,10 L19,3.5 C19,3.22385763 18.7761424,3 18.5,3 Z M12,7.5 L4,7.5 L4,8.5 L12,8.5 L12,7.5 Z" vector-effect="non-scaling-stroke" style="fill: rgb(56, 56, 56);"/>
            </g>
        </g>
    </svg>
</template>
<script>
export default {
    name: 'SeatIcon'
}
</script>